<section>
    @defer (when login()) {
        @if (login() && dealer().subDealers.length > 0) {
            <div class="flex justify-center">
                @for (location of locationLinks(); track location.name) {
                    <a
                        class="m-10"
                        [hyundaiRouterLink]="location.link"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLinkActive="pb-2 border-b-4 border-b-accent"
                    >
                        <button class="mx-auto h-full min-w-[150px] bg-blue p-8 px-11 text-white">
                            {{ location.name }}
                        </button>
                    </a>
                }
            </div>
        }
    }

    <ui-m030-c020-teaser-allrounder
        [image]="aboutUsContent().heroImage.url"
        [imageAlt]="aboutUsContent().heroImage.alt ?? aboutUsContent().headline"
        [isFirstView]="true"
    >
        <div editable="about-us.heroImage" type="image" imageEdit></div>

        <h1 [editable]="'about-us.headline'" headline>
            {{ aboutUsContent().headline }}
        </h1>

        <h2 class="mb-24" subheadline>{{ dealerLocationHeadline() }}</h2>

        <p [editable]="'about-us.heroCopy'" text>{{ aboutUsContent().heroCopy }}</p>

        <ng-container cta>
            <div>
                <a
                    ui-m010-c020-icon-link
                    class="inline-block"
                    hyundaiRouterLink="."
                    blockTriggerPreloading
                    fragment="kontakt"
                >
                    Kontakt & Öffnungszeiten
                </a>
            </div>
        </ng-container>
    </ui-m030-c020-teaser-allrounder>
</section>
<section>
    <div class="flex justify-center gap-40 pt-24 md:pt-40" role="tablist">
        <a
            class="border-b-4 font-headline text-14 leading-27 text-accent hover:font-medium md:text-18"
            [ngClass]="{
                'border-b-accent font-medium': activeTab() === ABOUT_US_TABS.TEAM,
                'border-b-transparent': activeTab() !== ABOUT_US_TABS.TEAM,
            }"
            [attr.aria-selected]="activeTab() === ABOUT_US_TABS.TEAM"
            [fragment]="ABOUT_US_TABS.TEAM"
            [editable]="'about-us.employees'"
            [id]="ABOUT_US_TABS.TEAM"
            hyundaiRouterLink="."
            replaceUrl
            role="tab"
        >
            {{ ABOUT_US_TABS.TEAM }}
        </a>

        <a
            class="border-b-4 font-headline text-14 leading-27 text-accent md:text-18"
            [ngClass]="{
                'border-b-accent font-medium': activeTab() === ABOUT_US_TABS.JOBS,
                'border-b-transparent': activeTab() !== ABOUT_US_TABS.JOBS,
            }"
            [attr.aria-selected]="activeTab() === ABOUT_US_TABS.JOBS"
            [fragment]="ABOUT_US_TABS.JOBS"
            [id]="ABOUT_US_TABS.JOBS"
            hyundaiRouterLink="."
            replaceUrl
            role="tab"
        >
            {{ ABOUT_US_TABS.JOBS }}
        </a>
    </div>
    @if (activeTab() === ABOUT_US_TABS.TEAM) {
        <div class="w-full animate-show">
            @if (aboutUsContent().contactEmployee; as contact) {
                <ui-m040-c130-contact-banner
                    [contact]="contact"
                    [cta]="dealer().phone"
                    [ctaLink]="'tel:' + dealer().phone"
                    [isFirstView]="activeTab() === ABOUT_US_TABS.TEAM"
                >
                    <p class="max-w-[570px] text-16 leading-27 text-black">
                        Wir sind für Sie da, wenn es darum geht, das passende Fahrzeug zu finden und beantworten alle
                        Ihre Fragen rund um Service, Teile und Zubehör.
                    </p>
                </ui-m040-c130-contact-banner>
            }

            @if (aboutUsEmployees()) {
                <ui-m030-c050-team-accordeon [teams]="aboutUsEmployees()" />
            }
        </div>
    } @else {
        @if (jobOfferContent(); as offerContent) {
            <ui-m030-c040-default-teaser
                class="block animate-show"
                [image]="offerContent.heroImage.url"
                [imageAlt]="offerContent.heroImage.alt"
                [list]="jobOfferBenefits()"
                [isFirstView]="activeTab() === ABOUT_US_TABS.JOBS"
            >
                <div class="ml-auto" [editable]="'about-us.jobOfferBenefits'" [type]="'text'" benefitsEdit></div>
                <div [editable]="'about-us.jobOfferHeroImage'" [type]="'image'" imageEdit></div>
                <h3 headline>{{ offerContent.headline }}</h3>

                <div [editable]="'about-us.jobOfferBtnLink'" cta>
                    <a class="button-primary" [hyundaiRouterLink]="offerContent.jobOfferBtn.link">
                        {{ offerContent.jobOfferBtn.text }}
                    </a>
                </div>
            </ui-m030-c040-default-teaser>
        }
    }
</section>

<section class="pb-24 md:pb-40" id="kontakt">
    <app-global-contact isFirstView="false" showAboutUsLink="false" />
</section>

@if ((aboutUsTeaser() || []).length > 0 || login()) {
    <section class="flex flex-col pb-40 pt-24 md:pb-[80px] md:pt-40">
        <h2
            class="inner-page-wrapper mb-24 font-headline text-31 font-medium leading-36 md:mb-0 md:text-center md:text-34 md:leading-41"
            [editable]="'about-us.aboutUsTeaser'"
        >
            Mehr zu uns
        </h2>
        <div>
            @for (teaser of aboutUsTeaser() || []; track teaser.id; let even = $even) {
                <ui-m030-c040-default-teaser
                    [image]="teaser.image"
                    [imageLeft]="even"
                    [isFirstView]="false"
                    [imageContains]="true"
                >
                    <h3 headline>{{ teaser.title }}</h3>
                    <span text>
                        {{ teaser.text }}
                    </span>
                    @if (teaser.link && teaser.linkText) {
                        <ng-container cta>
                            <div>
                                <a class="button-primary" [hyundaiRouterLink]="teaser.link">{{ teaser.linkText }}</a>
                            </div>
                        </ng-container>
                    }
                </ui-m030-c040-default-teaser>
            }
        </div>
    </section>
} @else if (login()) {
    <section class="flex flex-col pb-40 pt-24 md:pb-[80px] md:pt-40">
        <h2
            class="inner-page-wrapper mb-24 font-headline text-31 font-medium leading-36 md:mb-0 md:text-center md:text-34 md:leading-41"
            [editable]="'about-us.aboutUsTeaser'"
        >
            Mehr zu uns
        </h2>
    </section>
}
